import {isRawBoot} from '../../../src/models/api/rawBootModel';
import {bootLogger} from './bootLogger';
import {deleteRawBootCacheAsync, writeRawBootCacheAsync} from './rawBootCache';

/*
 * Helpers.
 */

export function tryReplaceRawBootCache(rawBoot: unknown) {
  // Cache only valid boots.
  if (!isRawBoot(rawBoot)) {
    return;
  }

  // Fire and forget.
  writeRawBootCacheAsync(rawBoot).catch((error) => {
    bootLogger.warn('Raw boot cache write error', {error: String(error)});
  });
}

export function tryDeleteRawBootCache() {
  // Fire and forget.
  deleteRawBootCacheAsync().catch((error) => {
    bootLogger.warn('Raw boot cache delete error', {error: String(error)});
  });
}
